import React, { useState } from 'react';
import { useI18n } from '../i18n';
import { SiteHeader, SiteFooter } from '../components/SiteChrome';
// @ts-ignore: allow side-effect CSS import without type declarations
import '../App.css';

/**
 * Root landing page. Shown at "/" so the bare domain never exposes the
 * private /create page. Lets a customer type their order ID and jump to
 * their tracker at /<orderId>.
 */
const LandingPage: React.FC = () => {
  const { t } = useI18n();
  const [id, setId] = useState('');

  const go = () => {
    const v = id.trim();
    if (!v) return;
    window.location.href = `/${encodeURIComponent(v)}`;
  };

  return (
    <div className="tc-page">
      <SiteHeader badge="nav.tracker" />

      <div className="tr-hero tr-hero-info">
        <div className="tr-hero-inner">
          <div className="tr-hero-icon-wrap">
            <i className="fas fa-magnifying-glass"></i>
          </div>
          <div className="tr-hero-text">
            <h1 className="tr-hero-label">{t('landing.title')}</h1>
            <p className="tr-hero-order">{t('landing.sub')}</p>
          </div>
        </div>
      </div>

      <div className="tr-content">
        <div className="tc-action-block">
          <div className="tc-action-block-header">
            <i className="fas fa-hashtag"></i>
            <span>{t('landing.header')}</span>
          </div>
          <div className="tc-form">
            <div className="tc-field">
              <label className="tc-label">{t('landing.label')}</label>
              <input
                className="tc-input"
                value={id}
                onChange={e => setId(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') go(); }}
                placeholder={t('landing.placeholder')}
                autoFocus
              />
            </div>
            <button
              className="tc-btn tc-btn-primary tc-btn-block"
              onClick={go}
              disabled={!id.trim()}
            >
              <i className="fas fa-arrow-right"></i>
              {t('landing.btn')}
            </button>
          </div>
        </div>
      </div>

      <SiteFooter />
    </div>
  );
};

export default LandingPage;
